
declare const require: any;
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
import TranslateService from "../../services/translate.service";
@Options({
  props: ["showLabel"]
})
export default class SelectLanguage extends Base {
  showLabel!: boolean;
  public ICON_DEFAULT = "";
  public FLAG_DEFAULT = true;

  public selectedCountry = {
    name: "English",
    code: "en",
    icon: this.ICON_DEFAULT,
    flag: this.FLAG_DEFAULT
  };

  public countries = [
    {
      name: "English",
      code: "en",
      icon: this.ICON_DEFAULT,
      flag: this.FLAG_DEFAULT
    },
    {
      name: "Vietnamese",
      code: "vi",
      icon: this.ICON_DEFAULT,
      flag: this.FLAG_DEFAULT
    }
  ];

  getFlagImage(countryName: string, test: any): string {
    const images: any = require.context(
      "../../assets/img/country/",
      false,
      /\.png$/
    );
    return images("./" + countryName + ".png");
  }

  setIconFlagForCountry(
    countryName: string,
    newIcon?: string,
    newFlag?: boolean
  ): void {
    for (let i = 0; i < this.countries.length; i++) {
      if (this.countries[i].name == countryName) {
        if (newIcon !== undefined) this.countries[i].icon = newIcon;
        if (newFlag !== undefined) this.countries[i].flag = newFlag;
      }
    }
  }

  getSelectedCountryCode(): string {
    return this.selectedCountry.code;
  }

  selectLang() {
    TranslateService.selectLanguage(this.selectedCountry.code);
  }
}
